let config = {
  site: 'api.passport.td.viessmann.cn',
  method: '/api/v1'
}
config.site = process.env.NODE_ENV === 'production' ? 'api.passport.td.viessmann.cn' : 'api.passport.dev2.zanservice.com'

export const apiRoot = 'http://'.concat(config.site, config.method)



// WEBPACK FOOTER //
// ./src/api/config.js